import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { setSearchProducts } from "../../redux/Reducer/Product/ProductSlice";
import SearchSelectProduct from "../Admin/Inventory/SearchSelectedProduct";
import apiAxios from "../../services/apiAxios";
import ProductImageGallery from "../common/ProductImageGallery";

function StoreProducts() {
  const activeForm = useSelector((state) => state.formSwitcher.activeForm); // Get active form from Redux
  const searchedProduct = useSelector((state) => state?.product?.searchProduct);
  const role = useSelector((state) => state?.auth?.role);
  const dispatch = useDispatch();

  const [selectedProduct, setSelectedProduct] = useState("");
  const [assignedDrugTags, setAssignedDrugTags] = useState([]);

  useEffect(() => {
    dispatch(setSearchProducts([]));
  }, [dispatch]);

  useEffect(() => {
    if (searchedProduct[0]?.drugTags?.length > 0) {
      setAssignedDrugTags(searchedProduct[0].drugTags);
    } else if (searchedProduct[0]?.drugs?.length > 0) {
      let isMounted = true;
      apiAxios
        .post("/api/product/drug/tags-by-names", { drugNames: searchedProduct[0].drugs })
        .then((res) => {
          if (isMounted && res?.data?.drugTags) {
            setAssignedDrugTags(res.data.drugTags);
          }
        })
        .catch((err) => {
          console.error("Error loading drug tags:", err);
        });
      return () => {
        isMounted = false;
      };
    } else {
      setAssignedDrugTags([]);
    }
  }, [searchedProduct]);
  const formik = useFormik({
    IID: "",
    initialValues: {
      productId: "",
      productName: "",
      manufacturer: "",
      units: "",
      type: "",
      drugs: [],
      storeQty: [
        { storeId: "", Qty: "" },
        { storeId: "", Qty: "" },
      ],
      discount:"",
      pricing: {
        mrp: "",
        gst: "",
      },
      images: [],
    },
  });

  // useEffect(() => {
  //   const fetchDrugs = drugsData.map((drug) => drug);
  //   setDrugs(fetchDrugs);
  //   dispatch(setSearchStore(""));
  // }, []);

  useEffect(() => {
    if (activeForm === "product") {
      formik.resetForm();
    } else {
      if (searchedProduct?.length > 0) {
        const productDetails = searchedProduct[0];
        formik.setValues({
          productId: productDetails?.productId || productDetails?.IID || "",
          productName: productDetails?.productName || "",
          manufacturer: productDetails?.manufacturer || "",
          units: productDetails?.uom || "",
          type: productDetails?.type || "",
          drugs: productDetails?.drugs || [],
          tags: productDetails?.tags || [],
          images: Array.isArray(productDetails?.images) ? productDetails.images : [],
          storeQty:
            productDetails?.storeQty?.length > 0
              ? productDetails.storeQty
              : [
                  { storeId: "", Qty: "" },
                  { storeId: "", Qty: "" },
                ],
          discount: productDetails?.lookupMargin?.discount,
          pricing: {
            mrp: productDetails?.pricing?.mrp || "",
            gst: productDetails?.pricing?.gst || "",
          },
        });
      } else {
        formik.resetForm();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeForm, searchedProduct]);

  const { values } = formik;

  return (
    <section className="bg-gray-100 rounded-[8px]">
      <div className="bg-white/50 py-3 px-5 rounded-t-[12px] border-b border-primary-100">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          <div className="flex-1 min-w-0">
            <SearchSelectProduct
              selectedProduct={selectedProduct}
              setSelectedProduct={setSelectedProduct}
              activeTabName="Products"
              role={role}
            />
          </div>
        </div>
      </div>
      <div className="bg-gray-100 py-4 px-5 rounded-b-[12px]">
        {searchedProduct?.length > 0 ? (
          <div className="bg-white rounded-[12px] border border-primary-100 p-6 shadow-sm mb-2">
            {/* Top Showcase: Image on Left + Primary Info & Key Metrics on Right */}
            <div className="grid grid-cols-12 gap-5 lg:gap-6 pb-6 border-b border-primary-100 mb-6">
              {/* Product Gallery */}
              <div className="col-span-12 md:col-span-5 lg:col-span-4 xl:col-span-3">
                <ProductImageGallery
                  images={searchedProduct[0]?.images || values?.images || []}
                  productName={values?.productName || searchedProduct[0]?.productName || "Product"}
                  readOnly={true}
                  aspectRatio="aspect-square"
                />
              </div>

              {/* Right: Product Identity & Key Metrics */}
              <div className="col-span-12 md:col-span-7 lg:col-span-8 xl:col-span-9 flex flex-col justify-between gap-4">
                {/* Header Info */}
                <div>
                  <div className="flex items-center gap-2 flex-wrap mb-1.5">
                    <h1 className="text-[20px] sm:text-[22px] font-extrabold text-secondry-800 tracking-tight">
                      {values?.productName || searchedProduct[0]?.productName || "Unnamed Product"}
                    </h1>
                    {(values?.productId || searchedProduct[0]?.IID) && (
                      <span className="px-2.5 py-0.5 bg-primary-100 text-primary-800 text-[11px] font-bold font-mono rounded-full border border-primary-200">
                        ID: #{values?.productId || searchedProduct[0]?.IID}
                      </span>
                    )}
                    {values?.type && (
                      <span className="px-2.5 py-0.5 bg-blue-50 text-blue-700 text-[11px] font-semibold rounded-full border border-blue-200 flex items-center gap-1.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                        {values?.type}
                      </span>
                    )}
                    <span
                      className={`px-2.5 py-0.5 text-[11px] font-semibold rounded-full border flex items-center gap-1.5 ${
                        Number(searchedProduct[0]?.productStock ?? values?.units ?? 0) > 0
                          ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                          : "bg-rose-50 text-rose-700 border-rose-200"
                      }`}
                    >
                      <span
                        className={`w-1.5 h-1.5 rounded-full ${
                          Number(searchedProduct[0]?.productStock ?? values?.units ?? 0) > 0
                            ? "bg-emerald-500"
                            : "bg-rose-500"
                        }`}
                      ></span>
                      Stock: {searchedProduct[0]?.productStock ?? values?.units ?? 0}{" "}
                      {searchedProduct[0]?.uom ? `(Pack of ${searchedProduct[0].uom})` : ""}
                    </span>
                  </div>

                  <p className="text-[12px] sm:text-[13px] text-primary-500 font-medium">
                    Manufactured by <strong className="text-secondry-700 font-semibold">{values?.manufacturer || searchedProduct[0]?.manufacturer || "N/A"}</strong>
                  </p>
                </div>

                {/* Key Metrics Cards */}
                <div className="grid grid-cols-12 gap-3 pt-1">
                  <div className="col-span-12 sm:col-span-4 bg-emerald-50/70 border border-emerald-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                    <span className="text-[10px] sm:text-[11px] font-bold uppercase text-emerald-700 tracking-wider">Maximum Retail Price</span>
                    <div className="mt-2 flex items-baseline gap-1">
                      <span className="text-[20px] sm:text-[22px] font-black text-emerald-900 leading-none">₹{values?.pricing?.mrp || searchedProduct[0]?.pricing?.mrp || "0"}</span>
                      <span className="text-[10px] text-emerald-600 font-medium">/ pack</span>
                    </div>
                  </div>

                  <div className="col-span-12 sm:col-span-4 bg-blue-50/70 border border-blue-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                    <span className="text-[10px] sm:text-[11px] font-bold uppercase text-blue-700 tracking-wider">GST Rate</span>
                    <div className="mt-2 flex items-baseline gap-1">
                      <span className="text-[20px] sm:text-[22px] font-black text-blue-900 leading-none">{values?.pricing?.gst || searchedProduct[0]?.pricing?.gst || "0"}%</span>
                    </div>
                  </div>

                  <div className="col-span-12 sm:col-span-4 bg-amber-50/70 border border-amber-200/80 rounded-[10px] p-3 sm:p-3.5 flex flex-col justify-between">
                    <span className="text-[10px] sm:text-[11px] font-bold uppercase text-amber-700 tracking-wider">Discount / Margin</span>
                    <div className="mt-2 flex items-baseline gap-1">
                      <span className="text-[20px] sm:text-[22px] font-black text-amber-900 leading-none">{values?.discount || searchedProduct[0]?.lookupMargin?.discount || "0"}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tags & Active Drugs */}
            <div className="grid grid-cols-12 gap-5">
              <div className="col-span-12 md:col-span-6 bg-primary-50/50 rounded-[12px] p-4 border border-primary-100">
                <div className="flex items-center justify-between pb-2.5 mb-3 border-b border-primary-200/60">
                  <div className="flex items-center gap-2">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                      <line x1="7" y1="7" x2="7.01" y2="7"></line>
                    </svg>
                    <h3 className="text-[12px] font-bold text-secondry-800 uppercase tracking-wider">
                      Tags & Classification
                    </h3>
                  </div>
                </div>

                <div className="space-y-3">
                  {/* Partition 1: Product Tags */}
                  <div className="bg-white/90 rounded-lg p-3 border border-primary-100 shadow-2xs">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[11px] font-bold text-primary-700 uppercase tracking-wider flex items-center gap-1.5">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-600">
                          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                          <line x1="7" y1="7" x2="7.01" y2="7"></line>
                        </svg>
                        Product Tags
                      </span>
                      <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full">
                        Product Level
                      </span>
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      {(searchedProduct[0]?.tags || values?.tags)?.length > 0 ? (
                        (searchedProduct[0]?.tags || values?.tags).map((tag, idx) => {
                          const tagName = typeof tag === "string" ? tag : tag?.name || tag?.tagName || tag?.tag;
                          const color = tag?.color || "#10B981";
                          return (
                            <span
                              key={idx}
                              style={{ backgroundColor: `${color}15`, borderColor: `${color}40`, color: color }}
                              className="px-2.5 py-1 rounded-md text-[12px] font-semibold border flex items-center gap-1.5 shadow-2xs transition-all"
                            >
                              <span style={{ backgroundColor: color }} className="w-2 h-2 rounded-full shrink-0"></span>
                              {tagName}
                            </span>
                          );
                        })
                      ) : (
                        <span className="text-[12px] text-primary-400 italic">No tags assigned</span>
                      )}
                    </div>
                  </div>

                  {/* Partition 2: Drug Tags (View only) */}
                  <div className="bg-white/90 rounded-lg p-3 border border-indigo-100 shadow-2xs">
                    <div className="flex items-center justify-between mb-1.5">
                      <span className="text-[11px] font-bold text-indigo-700 uppercase tracking-wider flex items-center gap-1.5">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-indigo-600">
                          <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
                          <path d="m8.5 8.5 7 7"></path>
                        </svg>
                        Drug Tags
                      </span>
                      <span className="text-[10px] font-semibold text-indigo-700 bg-indigo-50 border border-indigo-200 px-2 py-0.5 rounded-full flex items-center gap-1">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        View only (from Drugs page)
                      </span>
                    </div>
                    <p className="text-[11px] text-primary-400 mb-2">
                      Inherited from assigned drugs. To modify these tags, navigate to the <span className="font-semibold text-indigo-600">Drugs</span> page.
                    </p>
                    <div className="flex flex-wrap items-center gap-2">
                      {assignedDrugTags?.length > 0 ? (
                        assignedDrugTags.map((tag, idx) => {
                          const tagName = typeof tag === "string" ? tag : tag?.name || tag?.tagName || tag?.tag;
                          const color = tag?.color || "#6366F1";
                          const drugSources = tag?.drugs?.length ? tag.drugs : (tag?.fromDrug ? [tag.fromDrug] : []);
                          return (
                            <span
                              key={idx}
                              style={{ backgroundColor: `${color}15`, borderColor: `${color}40`, color: color }}
                              className="px-2.5 py-1 rounded-md text-[12px] font-semibold border flex items-center gap-1.5 shadow-2xs transition-all"
                              title={drugSources.length > 0 ? `Assigned to: ${drugSources.join(", ")}` : "Drug Tag"}
                            >
                              <span style={{ backgroundColor: color }} className="w-2 h-2 rounded-full shrink-0"></span>
                              <span>{tagName}</span>
                              {drugSources.length > 0 && (
                                <span className="text-[10px] font-normal px-1.5 py-0.5 rounded bg-white/80 border border-current opacity-80">
                                  {drugSources.length === 1 ? drugSources[0] : `${drugSources.length} drugs`}
                                </span>
                              )}
                            </span>
                          );
                        })
                      ) : (
                        <span className="text-[12px] text-primary-400 italic">
                          {(searchedProduct[0]?.drugs || values?.drugs)?.length > 0
                            ? "No tags assigned to the selected drugs"
                            : "No drugs assigned to this product"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-12 md:col-span-6 bg-primary-50/50 rounded-[10px] p-4 border border-primary-100">
                <h3 className="text-[12px] font-semibold text-primary-500 uppercase tracking-wider mb-2.5">
                  Drug Composition / Active Ingredients
                </h3>
                <div className="flex flex-wrap items-center gap-2">
                  {(searchedProduct[0]?.drugs || values?.drugs)?.length > 0 ? (
                    (searchedProduct[0]?.drugs || values?.drugs).map((drug, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-white border border-primary-200 text-secondry-700 text-[12px] font-medium rounded-lg shadow-2xs flex items-center gap-1.5"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary-500">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M12 8v8M8 12h8"></path>
                        </svg>
                        {drug}
                      </span>
                    ))
                  ) : (
                    <span className="text-[12px] text-primary-400 italic">No drug formulations specified</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-[12px] border border-dashed border-primary-200 p-8 text-center text-[13px] text-primary-400 font-medium">
            🔍 Search and select a product above to view details.
          </div>
        )}
      </div>
    </section>
  );
}

export default StoreProducts;
